export enum LicenceType {
  DAYS = "dniowe",
  YEARS = "roczne",
}
